import { render, staticRenderFns } from "./EditorDemoCTA.vue?vue&type=template&id=521f080c"
import script from "./EditorDemoCTA.vue?vue&type=script&lang=js"
export * from "./EditorDemoCTA.vue?vue&type=script&lang=js"
import style0 from "./EditorDemoCTA.vue?vue&type=style&index=0&id=521f080c&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports